import { apiEndPoints } from '@/common/api.endPoints';
import { FetchService } from '@/common/fetch.service';
import type {
  BulkCaseAssignmentPayload,
  BulkCaseAssignmentResponse,
  EligibleUwsResponse,
  ExceptionQueueResponse,
  ManagerTabPaginationParams,
  SmartRetryResponse,
  SpecializationOptionsResponse,
  TeamCapacityResponse,
  UpdateUwCapacityPayload,
} from './types';

const api = FetchService.getInstance;

const toPaginationParams = (
  params: ManagerTabPaginationParams = {},
): Record<string, string> => {
  const result: Record<string, string> = {
    page: String(params.page ?? 0),
    pageSize: String(params.pageSize ?? 25),
  };
  if (params.sortBy) result.sortBy = params.sortBy;
  if (params.sortOrder) result.sortOrder = params.sortOrder;
  if (params.filterBy) result.filterBy = params.filterBy;
  if (params.filterValue) result.filterValue = params.filterValue;
  if (params.countOnly) result.countOnly = 'true';
  return result;
};

export const getExceptionQueue = (
  params: ManagerTabPaginationParams = {},
): Promise<ExceptionQueueResponse> =>
  api().get(apiEndPoints.managerTabExceptionQueue, {
    params: toPaginationParams(params),
  });

export const getTeamCapacity = (): Promise<TeamCapacityResponse> =>
  api().get(apiEndPoints.managerTabTeamCapacity);

export const updateUwCapacity = (
  userId: number,
  payload: UpdateUwCapacityPayload,
): Promise<void> =>
  api().patch(`${apiEndPoints.managerTabTeamCapacity}/${userId}`, {
    body: payload,
  });

export const getSmartRetry = (
  params: ManagerTabPaginationParams = {},
): Promise<SmartRetryResponse> =>
  api().get(apiEndPoints.managerTabSmartRetry, {
    params: toPaginationParams(params),
  });

export const releaseSmartRetryCase = (applicationId: number): Promise<void> =>
  api().patch(`${apiEndPoints.managerTabSmartRetry}/${applicationId}/release`);

export const getEligibleUws = (): Promise<EligibleUwsResponse> =>
  api().get(apiEndPoints.managerTabEligibleUws);

export const getSpecializationOptions =
  (): Promise<SpecializationOptionsResponse> =>
    api().get(apiEndPoints.managerTabSpecializationOptions);

export const bulkCaseAssignment = (
  payload: BulkCaseAssignmentPayload,
): Promise<BulkCaseAssignmentResponse> =>
  api().post(apiEndPoints.managerTabBulkCaseAssignment, { body: payload });
